import { useState, useEffect } from 'react';

const DESKTOP_BREAKPOINT = 1024;

function checkIsDesktop(): boolean {
  if (typeof window === 'undefined') return false;
  return window.innerWidth >= DESKTOP_BREAKPOINT;
}

export function useDeviceType() {
  const [isDesktop, setIsDesktop] = useState<boolean>(() => checkIsDesktop());

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(checkIsDesktop());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isDesktop;
}